import { Card } from "PFComponents/card/card";
import { Tab, Tabs, TabVariant } from "PFComponents/tabs";
import { useMemo, useState } from "react";
import { useTranslation } from "react-i18next";

import { FiltersBar } from "../common/filters_bar";
import css from "./insights_page.module.scss";
import { DailyBench } from "./subPages/daily_bench";
import { OpenRoles } from "./subPages/open_roles";
import { RoleClosures } from "./subPages/role_closures";
import { SkillsAnalytics } from "./subPages/skills_analytics";

enum SubPage {
  DailyBench = "daily_bench",
  OpenRoles = "open_roles",
  RoleClosures = "role_closures",
  SkillsAnalytics = "skills_analytics"
}

export const InsightsPage = () => {
  const [activeSubPage, setActiveSubPage] = useState(SubPage.DailyBench);
  const { t } = useTranslation("insights");

  const subPageNameMapping = {
    [SubPage.DailyBench]: t("subPage.dailyBench"),
    [SubPage.OpenRoles]: t("subPage.openRoles"),
    [SubPage.RoleClosures]: t("subPage.roleClosures"),
    [SubPage.SkillsAnalytics]: t("subPage.skillsAnalytics")
  };

  const SubPageComponent = {
    [SubPage.DailyBench]: DailyBench,
    [SubPage.OpenRoles]: OpenRoles,
    [SubPage.RoleClosures]: RoleClosures,
    [SubPage.SkillsAnalytics]: SkillsAnalytics
  }[activeSubPage];

  const tabs: Tab[] = useMemo(
    () =>
      Object.keys(SubPage).map((item) => ({
        id: SubPage[item],
        title: subPageNameMapping[SubPage[item]]
      })),
    []
  );

  return (
    <>
      <FiltersBar />
      <div className={css.insightsContainer}>
        <Card className={css.navigation}>
          <Tabs
            tabs={tabs}
            variant={TabVariant.Vertical}
            onChange={(id: SubPage) => setActiveSubPage(id)}
            activeTab={activeSubPage}
          />
        </Card>
        <SubPageComponent />
      </div>
    </>
  );
};
